import { TrendingUp } from '@mui/icons-material';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography
} from '@mui/material';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { getChartOptions } from '../../utils/chart-helpers';
import SectionHeader from './SectionHeader';

export default function MonthlyStatsChart({
  chartData,
  loading,
  selectedYear,
  availableYears,
  onYearChange,
  ytdPackageTotal,
  ytdShipmentTotal
}) {
  if (!chartData) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="300px"
      >
        <Typography variant="h6" color="textSecondary">
          {loading
            ? 'Loading monthly statistics...'
            : 'No monthly data available'}
        </Typography>
      </Box>
    );
  }

  const currentMonth = new Date().toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric'
  });

  return (
    <Paper sx={{ p: 3, height: '100%' }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <SectionHeader
          title="Monthly Statistics Trend"
          icon={<TrendingUp />}
        />
        <Box display="flex" alignItems="center" gap={2}>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="year-select-label">Year</InputLabel>
            <Select
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              label="Year"
              onChange={onYearChange}
            >
              {availableYears.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box textAlign="right">
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ fontSize: '0.8rem' }}
            >
              As of {currentMonth}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              sx={{ fontWeight: 600, fontSize: '0.85rem' }}
            >
              YTD Package Details: {(ytdPackageTotal || 0).toLocaleString()}
            </Typography>
            <Typography
              variant="body2"
              color="error"
              sx={{ fontWeight: 600, fontSize: '0.85rem' }}
            >
              YTD Shipment Tracking: {(ytdShipmentTotal || 0).toLocaleString()}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: 400 }}>
        <Line
          options={getChartOptions(chartData)}
          data={chartData}
        />
      </Box>
    </Paper>
  );
}
